export default __webpack_public_path__ + "static/media/border_gray_logo.b5ae4c50.svg";